import { create } from 'zustand';

const useNotificationStore = create((set, get) => ({
  // State
  unreadCounts: {},    // channelId -> count
  mentionCounts: {},   // channelId -> count
  dmUnreadCounts: {},  // dmId -> count

  // Actions
  setUnread: (channelId, count) =>
    set((state) => ({
      unreadCounts: { ...state.unreadCounts, [channelId]: count },
    })),

  incrementUnread: (channelId) =>
    set((state) => ({
      unreadCounts: {
        ...state.unreadCounts,
        [channelId]: (state.unreadCounts[channelId] || 0) + 1,
      },
    })),

  resetUnread: (channelId) =>
    set((state) => ({
      unreadCounts: { ...state.unreadCounts, [channelId]: 0 },
      mentionCounts: { ...state.mentionCounts, [channelId]: 0 },
    })),

  setMention: (channelId, count) =>
    set((state) => ({
      mentionCounts: { ...state.mentionCounts, [channelId]: count },
    })),

  incrementMention: (channelId) =>
    set((state) => ({
      mentionCounts: {
        ...state.mentionCounts,
        [channelId]: (state.mentionCounts[channelId] || 0) + 1,
      },
    })),

  setDmUnread: (dmId, count) =>
    set((state) => ({
      dmUnreadCounts: { ...state.dmUnreadCounts, [dmId]: count },
    })),

  incrementDmUnread: (dmId) =>
    set((state) => ({
      dmUnreadCounts: {
        ...state.dmUnreadCounts,
        [dmId]: (state.dmUnreadCounts[dmId] || 0) + 1,
      },
    })),

  resetDmUnread: (dmId) =>
    set((state) => ({
      dmUnreadCounts: { ...state.dmUnreadCounts, [dmId]: 0 },
    })),

  // Computed helpers
  getTotalUnread: () => {
    const state = get();
    const channelTotal = Object.values(state.unreadCounts).reduce(
      (sum, c) => sum + c,
      0,
    );
    const dmTotal = Object.values(state.dmUnreadCounts).reduce(
      (sum, c) => sum + c,
      0,
    );
    return channelTotal + dmTotal;
  },

  getTotalMentions: () =>
    Object.values(get().mentionCounts).reduce((sum, c) => sum + c, 0),
}));

export default useNotificationStore;
